/** Trims each address and keeps the first spelling of every case-insensitive duplicate; a blank stays an entry so it is reported at its own index. */
export const distinctEmailEntries = (entries: readonly string[]): string[] => {
  const byLowercase = new Map<string, string>()
  for (const entry of entries) {
    const trimmed = entry.trim()
    if (!byLowercase.has(trimmed.toLowerCase())) byLowercase.set(trimmed.toLowerCase(), trimmed)
  }
  return [...byLowercase.values()]
}
